import { render, staticRenderFns } from "./CreateApp.vue?vue&type=template&id=6036673c&"
import script from "./CreateApp.vue?vue&type=script&lang=js&"
export * from "./CreateApp.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/appstore-landing2.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports